export const getBackgroundColor = (background: 'White' | 'Gray' | 'Gradiant') => {
  switch (background) {
    case 'White':
      return 'bg-white py-10 lg:py-16'
    case 'Gray':
      return 'bg-light-gray py-10 lg:py-16'
    case 'Gradiant':
      return 'bg-gradient-to-b from-[rgb(129,12,168)] from-[0%] to-[rgb(45,3,59)] to-[100%]' // TODO: add gradient color
    default:
      return 'bg-white py-10 lg:py-16'
  }
}
